export default "__VITE_ASSET__BU1XgqTL__"